import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wConsts from "../consts/website-consts";
import * as wActs from "../actions/website-actions";
import NotFound from "../components/notfound";
import SideBanners from "../components/sidebanners";
import TGWidget from "../components/tgwidget";
import * as tgCdes from "../consts/widetcodes";
import {Link} from "react-router-dom";
import SwBanner from "../components/swbanner";
import BuyAdBanner from "../components/buyadbanner";
import SubHeader from "../components/subheader";
import LinkHeader from "../components/linkheader";

const enHolland = `<iframe id="tgw_5e142d8583ba88f6638b4567" frameborder="0" scrolling="no" horizontalscrolling="no" verticalscrolling="no" width="100%" height="1800px" async></iframe><script>document.addEventListener("DOMContentLoaded",function(){document.getElementById("tgw_5e142d8583ba88f6638b4567").setAttribute("src","https://tgwidget.com/channel/v2.0/?id=5e142d8583ba88f6638b4567")})</script>`;
const enHollandButton = "<iframe src=\"https://tgwidget.com/widget/btn/?id=5e142d8583ba88f6638b4567\" frameborder=\"0\" scrolling=\"no\" horizontalscrolling=\"no\" verticalscrolling=\"no\" width=\"250px\" height=\"50px\" async></iframe>";

class Home extends Component {


  constructor(props) {
    super(props);
    this.state = {
      Channels: tgCdes.Channels.map((v) => { return {value: v.value, label: v.label, url: v.url, isSelected: false} })
    };
  }


  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "home" });

  }

  changeChannel(e,sel) {
    this.props.history.push(tgCdes.Channels[e.target.selectedIndex].url);
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  render() {

    if(this.props.WebPage.PageLoaded && this.props.WebPage.Page.Name === "404") {
      return <NotFound />;
    }

    let chan = "EnTurkey";
    if(!wActs.isNullOrEmpty(this.props.WebPage.Page.Settings.Channel)) {
      chan = this.props.WebPage.Page.Settings.Channel.replace("Info","");
    }
    let tmp = this.props.Template;
    let acc = "";
    if(!wActs.isNullOrUndefined(tmp)) {
      if(!wActs.isNullOrUndefined(tmp.Country) && !wActs.isNullOrEmpty(tmp.Country.Code)) {
        acc=tmp.Country.Code;
      }
    }
    if(acc=="") {
      acc = this.props.WebPage.Request.CountryCode;
    }
    if(acc=="") {
      acc="TR";
    }

    return (
      <main className={`main`}>
        <SubHeader/>
        <div className="container">
          <LinkHeader/>
          <div className="content flex flex--between">
            <SideBanners isLeft={true}/>
            <div className="content-body">
              <TGWidget WidgetKey={chan}/>
              <div className="h2 text-center content-body-title" style={{marginTop: "70px"}} dangerouslySetInnerHTML={{__html: this.getTranslation("page.advertise.advertiseonourtelegramchannels").replace("{{SupportUrl}}", wActs.getCultPath(this.props.WebPage,"/support"))}}>
              </div>
            </div>
            <SideBanners isLeft={false}/>
          </div>
        </div>
        <div className="clear"></div>
        <div className={"flex-center mobile-padding"} style={{flexDirection: "column",margin: "40px auto"}}>
          <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.WebPage.Request.AnonymousId} country={acc}  tagText={this.props.HtmlSections['Adserver-728x90-leaderboard']} className="flex flex--center"></SwBanner>
        </div>
        <div className="clear"></div>
        <div className="seo-container">
          <h1 className={"h1-top"} style={{marginBottom: "5px"}}>{this.props.WebPage.Page.H1Text}</h1>
        </div>
        <div className="seo-container">
          {(!wActs.isNullOrEmpty(this.props.WebPage.Page.H1TextBlock)) &&
            <p ref={(r) => {this.BottomSeo = r}} className="h1textblock" style={{textAlign: "justify",padding: "10px"}} dangerouslySetInnerHTML={{__html: this.props.WebPage.Page.H1TextBlock}}></p>
          }
        </div>

      </main>
    );
  }

  componentDidUpdate() {
    try {
      this.BottomSeo.innerHTML = this.props.WebPage.Page.H1TextBlock;
    } catch(ex) {}
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    HtmlSections: state.Website.Settings.HtmlSections
  };
};

export default connect(mapStateToProps)(Home);
